import { useState, useEffect } from 'react';
import { getImageUrl } from '@/utils/imageDB';

export function useGalleryUrls(ids: string[] | undefined): string[] {
  const [urls, setUrls] = useState<string[]>([]);

  useEffect(() => {
    if (!ids || ids.length === 0) {
      setUrls([]);
      return;
    }
    let cancelled = false;
    const objectUrls: string[] = [];

    Promise.all(ids.map(id => getImageUrl(id))).then(results => {
      if (cancelled) return;
      const valid: string[] = [];
      results.forEach(url => {
        if (url) {
          objectUrls.push(url);
          valid.push(url);
        }
      });
      setUrls(valid);
    });

    return () => {
      cancelled = true;
      objectUrls.forEach(u => URL.revokeObjectURL(u));
    };
  }, [JSON.stringify(ids)]);

  return urls;
}
